<div class="case-sheet-container p-4 md:p-6">
  
  <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <!-- TITLE -->
  <div class="text-lg mb-5 font-semibold">
    {{userType==='lawyer'?'Case Sheet':'Appeal Sheet'}}
  </div>


  <form [formGroup]="searchForm" 
        class="bg-fieldset mb-4 p-4 rounded shadow-sm grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-start" 
        (ngSubmit)="onSearch()">

    <div class="w-full">
      <mat-label class="block mb-1 text-sm text-gray-600">From Date</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="fromDate" [matDatepicker]="picker" placeholder="Choose a date" [max]="today">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="searchForm.get('fromDate')?.hasError('required')">
          Field value required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="w-full">
      <mat-label class="block mb-1 text-sm text-gray-600">To Date</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="toDate" [matDatepicker]="picker2" placeholder="Choose a date" 
               [min]="searchForm.get('fromDate')?.value || null" [max]="today">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
        <mat-error *ngIf="searchForm.get('toDate')?.hasError('required')">
          Field value required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="w-full" *ngIf="!isAppeal">
  <mat-label class="block mb-1 text-sm text-gray-600">Case Category</mat-label>
  <mat-form-field appearance="outline" class="w-full">
    <mat-select formControlName="caseCategory">
      <mat-option *ngFor="let category of caseCategories" [value]="category.key">
        {{ category.value }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="searchForm.get('caseCategory')?.hasError('required')">
      Field value required
    </mat-error>
  </mat-form-field>
</div>

    <div class="w-full">
      <label class="hidden sm:block mb-1 text-sm opacity-0 select-none">Action</label>
      
      <div class="flex items-center gap-3 h-[56px] -mt-3 lg:mb-5">
        <button type="reset" mat-stroked-button color="primary" class="w-full sm:w-auto h-10" (click)="onReset()">
          Reset
        </button>
        <button type="submit" mat-flat-button color="primary" class="w-full sm:w-auto h-10">
          Search
        </button>
      </div>
    </div>
    
  </form>

  <div *ngIf="isLoading" class="flex justify-center items-center py-8">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div *ngIf="!isLoading && totalCount > 0">
    <div class="flex flex-wrap justify-between items-center mb-3 gap-2">
      <p class="font-medium text-base">
      {{userType==='lawyer'?'Case Sheet':'Appeal Sheet'}} List
    </p>
      <button mat-button color="primary" class="print-button" (click)="onPrint()">
        <mat-icon class="print-icon mr-1" aria-hidden="true">print</mat-icon>
        <span>Print</span>
      </button>
    </div>

  <div class="responsive-table-wrapper">
  <!-- <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport main-table-viewport"> -->

    <table mat-table [dataSource]="caseList" matSort class="mat-elevation-z0">

      <ng-container *ngFor="let col of columnDefinitions" [matColumnDef]="col.column">

        <!-- HEADER -->
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ col.labels[userType] }}
        </th>

        <!-- DATA -->
        <td mat-cell *matCellDef="let element">

          <ng-container [ngSwitch]="col.column">
           
            <span *ngSwitchCase="'caseId'">   {{ element.caseId }} </span>  
            <span *ngSwitchCase="'caseNumber'"> {{ element.caseNumber }}</span>
            <span *ngSwitchCase="'appellantsParty'"> {{ element.appellantsParty }}</span>
            <span *ngSwitchCase="'respondentsParty'">{{ element.respondentsParty }} </span>
            <span *ngSwitchCase="'documentStatus'">{{ element.documentStatus }} </span>

          </ng-container>

        </td>

      </ng-container>

      <!-- HEADER -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <!-- ROWS -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  <!-- </cdk-virtual-scroll-viewport> -->
</div>